import angular from 'angular'
import component from './contentTools.component'

export default angular
  .module('ellipsis.contentTools', [])
  .component('contentTools', component)
